<app-compose-mail appendTo='body' style="z-index: 9999999;"></app-compose-mail>
<button mat-raised-button style="background: #E0F2FD;position: absolute;top: 160px;right: 350px;z-index: 999999;"
    (click)="ismail=true;printBadge()">Print Badge </button>
<button mat-raised-button style="background: #E0F2FD;position: absolute;top: 160px;right: 220px;z-index: 999999;"
    (click)="ismail=true;sendEBAdge()">Send E-Badge </button>
<div class="row">
    <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
        <mat-card>
            <div class="table-container mat-elevation-z8" style="    height: 90%;
            overflow: auto;">
                <table mat-table #table [dataSource]="dataSource"
                    style="width: 100%;height: 200px!important;overflow: scroll;">
                    <ng-container matColumnDef="nom" sticky>
                        <th mat-header-cell *matHeaderCellDef> Nom </th>
                        <td mat-cell *matCellDef="let row"> {{row.nom}} </td>
                    </ng-container>

                    <ng-container matColumnDef="mobile">
                        <th mat-header-cell *matHeaderCellDef> Mobile </th>
                        <td mat-cell *matCellDef="let row"> {{row.mobile}} </td>
                    </ng-container>

                    <ng-container matColumnDef="position">
                        <th mat-header-cell *matHeaderCellDef> Position </th>
                        <td mat-cell *matCellDef="let row"> {{row.position}} </td>
                    </ng-container>
                    <ng-container matColumnDef="description">
                        <th mat-header-cell *matHeaderCellDef> Pass </th>
                        <td mat-cell *matCellDef="let row"> {{row.description}} </td>
                    </ng-container>
                    <ng-container matColumnDef="action" style="width: 100px;">
                        <th mat-header-cell *matHeaderCellDef> Action </th>
                        <td mat-cell *matCellDef="let row">

                            <button mat-icon-button (click)="removeDelegate(row)">
                                <mat-icon>remove</mat-icon>
                            </button>


                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="['nom','mobile','position','description','action']"></tr>
                    <tr mat-row *matRowDef="let row; columns: ['nom','mobile','position','description','action'];"
                        [style.background]="row.idDelegate === selectedDelegateId ? '#F58632' : ''"
                        (click)="select(row)"></tr>
                </table>
            </div>
            <button mat-mini-fab (click)="ajouterNouveau()" color="primary">
                <mat-icon>add</mat-icon>
            </button>


        </mat-card>
    </div>

    <div *ngIf="selectedDelegate" class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
        <mat-card>
            <div class="row">

                <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                    <mat-form-field class="example-full-width">
                        <input matInput placeholder="Nom" [(ngModel)]="selectedDelegate.nom" (input)='save()'>
                    </mat-form-field>
                </div>
                <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                    <mat-form-field class="example-full-width">
                        <input matInput placeholder="Mobile" [(ngModel)]="selectedDelegate.mobile" (input)='save()'>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">

                <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                    <mat-form-field class="example-full-width">
                        <input matInput placeholder="E-Mail" [(ngModel)]="selectedDelegate.mail" (input)='save()'
                            type="mail">
                    </mat-form-field>
                </div>
                <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                    <mat-form-field floatPlaceholder="always">
                        <input matInput placeholder="Position" [matAutocomplete]="autocompleteTemplateRefId"
                            (input)='save()' [(ngModel)]="selectedDelegate.position"
                            (ngModelChange)="filterPositions(selectedDelegate.position)">
                    </mat-form-field>

                    <mat-autocomplete (optionSelected)='save()' #autocompleteTemplateRefId="matAutocomplete">
                        <mat-option *ngFor="let position of positionsS" [value]="position">
                            {{position}}
                        </mat-option>
                    </mat-autocomplete>
                </div>
            </div>



            <div class="row">

                <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                    <mat-form-field floatPlaceholder="Pays">
                        <input matInput placeholder="Pays" [matAutocomplete]="autocompletePaysId" (input)='save()'
                            (ngModelChange)="filterPays(selectedDelegate.pays)" [(ngModel)]="selectedDelegate.pays">
                    </mat-form-field>

                    <mat-autocomplete (optionSelected)='save()' #autocompletePaysId="matAutocomplete">
                        <mat-option *ngFor="let pays of payss | async" [value]="pays.designationFr">
                            {{pays.designationFr}}
                        </mat-option>
                    </mat-autocomplete>
                </div>
                <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                    <mat-form-field style="width: 100% ;  ">
                        <mat-select [(ngModel)]="selectedDelegate.description" placeholder="Type de pass"
                            (selectionChange)='save()'>

                            <mat-option [value]="'FREEDOM PASS'">
                                FREEDOM PASS
                            </mat-option>
                            <mat-option [value]="'VIP DELEGATE'">
                                VIP DELEGATE
                            </mat-option>
                            <mat-option [value]="'SPEAKER'">
                                SPEAKER
                            </mat-option>


                        </mat-select>
                    </mat-form-field>
                </div>
            </div>





            <mat-form-field class="full-width" style="margin: 5mm;">
                <textarea matInput [(ngModel)]="selectedDelegate.note" (keyup)='save()'
                    [ngModelOptions]="{standalone: true}" placeholder="Notes" rows="7"></textarea>
            </mat-form-field>



        </mat-card>
    </div>



</div>